import type { Organization } from "@/types"
import { LOGOUT_RTK, RECEIVE_INITIAL_STATE } from "@/components/access/ducks/Actions"
import { createSlice, type PayloadAction } from "@reduxjs/toolkit"
import { clearSuffixLinkThunk, setSuffixLinkThunk } from "./thunks"

type NavigationState = {
  drawerOpen: boolean
  hasRouted: boolean
  snackbarContent: string
  sidebarDrawerOpen: boolean
  organizations: Organization[]
}

const initialState: NavigationState = {
  drawerOpen: false,
  hasRouted: false,
  sidebarDrawerOpen: false,
  snackbarContent: "",
  organizations: [],
}

const navigationSlice = createSlice({
  name: "navigation/user",
  initialState,
  reducers: {
    openDrawer(state) {
      state.drawerOpen = true
    },
    closeDrawer(state) {
      state.drawerOpen = false
    },
    toggleSidebarMenu(state) {
      state.sidebarDrawerOpen = !state.sidebarDrawerOpen
    },
    setSnackbar(state, action: PayloadAction<string>) {
      state.snackbarContent = action.payload
    },
    clearSnackbar(state) {
      state.snackbarContent = ""
    },
    setHasRouted(state, action: PayloadAction<boolean>) {
      state.hasRouted = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(LOGOUT_RTK, (_state, _action) => initialState)
      .addCase(RECEIVE_INITIAL_STATE, (state, action) => {
        // @ts-expect-error: TODO: fix later
        state.organizations = action.response.organizations
      })
      // WARN: this may look like a normal reducer, but some action dispatches depend on it implicitly throughout the app
      // so keep this as async thunk until that is resolved
      .addCase(setSuffixLinkThunk.fulfilled, (state) => {
        state.drawerOpen = true
      })
      .addCase(clearSuffixLinkThunk.fulfilled, (state) => {
        state.drawerOpen = false
      })
  },
})

export const NavigationActions = {
  ...navigationSlice.actions,
  clearSuffixLink: clearSuffixLinkThunk,
  setSuffixLink: setSuffixLinkThunk,
}

export default navigationSlice.reducer
